import { Component, inject, input, LOCALE_ID, output } from '@angular/core';
import { Error } from '../../../public-user-component/auth/shared/error/error';

@Component({
  selector: 'app-cancel-pharmacy-dialog',
  templateUrl: './cancel-pharmacy-dialog.html',
  styleUrl: './cancel-pharmacy-dialog.scss',
  standalone: true,
  imports: [Error],
})
export class CancelPharmacyDialog {
  private locale = inject(LOCALE_ID);
  pharmacyName = input.required<string>();
  loadingCancel = input.required<boolean>();
  errorCancel = input.required<string>();
  close = output();
  confirm = output();
  pharmacyRequestId = input.required<string>();

  onClose() {
    this.close.emit();
  }

  onConfirm() {
    this.confirm.emit();
  }
  isArabic() {
    return this.locale.startsWith('ar');
  }
}
